import React, { Component } from 'react'
import { connect } from 'react-redux'
import MenuItem from 'material-ui/MenuItem'
import Select from 'components/Select'
import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		vendor: doc(state, props.objectID)
	})
)

const categories = [
	{value:"loan", primaryText:"Loan"}
  , {value:"insurance", primaryText:"Insurance"}
  , {value:"taxes", primaryText:"Taxes"}
  , {value:"hoa", primaryText:"Hoa"}
  , {value:"escrow", primaryText:"Escrow"}
  , {value:"utilities", primaryText:"Utilities"}
]

export class CategorySelect extends Component{
	render(){
		let { props } = this
		return(
			<Select
				key={props.vendor.subtype}
				hintText="Select category"
				title="Please choose category"
				value={props.vendor.subtype}
				icon= {
					<i
						className="material-icons"
						style={{
							float: "left"
							, width: "26px"
							, position: "relative"
							, top: "-1px"
							, left: "-6px"
							, color: "#5ae4c3"
						}}
					>
						view_headline
					</i>
				}
				onChange={(evt, indx, value) =>{
					props.STAGE({
						_id: props.objectID
						, subtype: value
					})
				}}
			>
				{categories.map(cat=> <MenuItem key={cat.value} value={cat.value} primaryText={cat.primaryText} /> )}
			</Select>
		)
	}
}

export default connect(select, dataActions)(CategorySelect)



// WEBPACK FOOTER //
// ./src/routes/manager/vendorForm/CategorySelect.js